export default __webpack_public_path__ + "static/media/blockpix.e6ddf10d.svg";